import { Injectable } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { cloneDeep } from 'lodash';

import { ModalService } from '@app/core/modal.service';
import { SourceCodeModalComponent as ModalComponent } from './source-code-modal.component';

@Injectable({ providedIn: 'root' })
export class SourceCodeModalService {
  constructor(
    private modalService: ModalService,
    private modal: NgbActiveModal
  ) {}

  open(properties: { srcCode: string }, options?: NgbModalOptions) {
    const newOptions = cloneDeep(options || {});
    newOptions.size = 'xl';
    newOptions.windowClass = (newOptions.windowClass || '').split(/\s+/).join(' ');
    return this.modalService.open(ModalComponent, properties, newOptions);
  }

  dismiss() {
    this.modal.dismiss();
  }
}
